import { Switch, Route } from "react-router-dom";
import { TierList } from "./pages/Default/TierList";
import { AppRoutes, RouterPaths } from "@ugg/shared/routes/app-routes";
import { CombatTierListContainer } from "./pages/Combat/CombatTierListContainer";
import { ObjectivesTierListContainer } from "./pages/Objectives/ObjectivesTierListContainer";
import { DuoTierListContainer } from "./pages/Duo/DuoTierListContainer";

export const TierListRoutes = () => {
  return (
    <Switch>
      <Route path={AppRoutes.DUO_TIER_LIST} component={DuoTierListContainer} />
      <Route path={AppRoutes.COMBAT_TIER_LIST} component={CombatTierListContainer} />
      <Route path={AppRoutes.OBJECTIVES_TIER_LIST} component={ObjectivesTierListContainer} />
      <Route path={RouterPaths.TIER_LIST} component={TierList} />
    </Switch>
  );
};
